import type { Client } from '../client';
import type {
  PushRegisterRequest,
  NotificationPreferences,
} from '../types';

export function pushEndpoints(client: Client) {
  return {
    register: (data: PushRegisterRequest) =>
      client.post<{ status: string }>('/api/push/register', data),

    unregister: (data: PushRegisterRequest) =>
      client.del<{ status: string }>('/api/push/unregister', data),

    getPreferences: () =>
      client.get<NotificationPreferences>('/api/push/preferences'),

    updatePreferences: (data: Partial<NotificationPreferences>) =>
      client.put<{ status: string }>('/api/push/preferences', data),
  };
}
